/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ComponentProps, ReactNode } from "react";
import { ErrorWrap } from "./ErrorWrap";
import { LoaderWrap } from "./LoaderWrap";

type ErrorWrapProps = ComponentProps<typeof ErrorWrap>;
type LoaderWrapProps = ComponentProps<typeof LoaderWrap>;

type Props = {
  children: ReactNode;
  loaderProps: Omit<LoaderWrapProps, "children">;
  errorProps: ErrorWrapProps;
};

export function UniversalWrap({ children, loaderProps, errorProps }: Props) {
  return (
    <LoaderWrap {...loaderProps}>
      <ErrorWrap {...errorProps}>{children}</ErrorWrap>
    </LoaderWrap>
  );
}
